import { SortTypeHelp } from '@shared/components/NewSort/constants';

export const SEARCH_TYPES = t => [
  {
    id: 1,
    value: 'TITLE',
    label: t('byName'),
  },
  {
    id: 2,
    value: 'TAG',
    label: t('byTag'),
  },
];

export const SORT_TYPES = t => [
  {
    name: t('rate'),
    value: ['rate,desc', 'rate,asc'],

    type: SortTypeHelp.RATE,
  },
  {
    name: t('date'),
    value: ['createdDate,asc', 'createdDate,desc'],
    type: SortTypeHelp.DATE,
  },
];
